<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">ACKNOWLEDGEMENTS</p>
<p class="noindent"><i>Thanks to the following:</i></p>
<p class="noindent1">W<span class="small">AREHAM</span> S<span class="small">UMMER OF</span> C<span class="small">ELEBRATION</span> C<span class="small">OMMITTEE</span>:</p>
<p class="noindent">Coordinator: Claire Smith</p>
<p class="noindent">President: Rudy Santos</p>
<p class="noindent">Vice-president: Nancy Miller</p>
<p class="noindent">Clerk: Angela Dunham</p>
<p class="noindent">Treasurer: Robert Powilatis</p>
<p class="noindent">Board of directors: Sharon Boyer, Jovina Dean, Eleanor Martin, Malcolm Phinney, W. Robert White</p>
<p class="noindent">Committee members: Nora Bicki, Robert Blair, Linda Burke, Mary Jane Burke, Jacqui Healey, William Heaney, Mel Lazarus, Laura Lopes, Deborah McGonnell, John McGonnell, Clifford Sylvia, Paula Tufts</p>
<p class="noindent1">L<span class="small">IBRARY</span> B<span class="small">OARD OF</span> T<span class="small">RUSTEES</span>:</p>
<p class="noindent">Chair: Bethany Gay</p>
<p class="noindent">Vice-chair: Roger Bacchieri</p>
<p class="noindent">Secretary: William White</p>
<p class="noindent">Members: Johnna Fredrickson, Rachel Kuklinski, M. Kathleen LaFlamme Diane O’Brien</p>
<p class="noindent">Liaison to the board: Judy Whiteside</p>
<p class="noindent1">W<span class="small">AREHAM</span> H<span class="small">ISTORICAL</span> C<span class="small">OMMISSION</span>:</p>
<p class="noindent">Chair: Angela M. Dunham</p>
<p class="noindent">Vice-chair: Mack Phinney</p>
<p class="noindent">Treasurer: Len Boutin</p>
<p class="noindent">Clerk: Cheryl Knapp</p>
<p class="noindent">Board of selectmen liaison: Alan Slavin</p>
<p class="noindent1">W<span class="small">AREHAM</span> H<span class="small">ISTORICAL</span> S<span class="small">OCIETY</span> O<span class="small">FFICERS</span>:</p>
<p class="noindent">President: Angela M. Dunham</p>
<p class="noindent">Vice-president: Mary Hull</p>
<p class="noindent">Treasurer: Sandy Slavin</p>
<p class="noindent">Secretary: Cathy Phinney</p>
<p class="noindent1">W<span class="small">AREHAM</span> H<span class="small">ISTORICAL</span> S<span class="small">OCIETY</span> B<span class="small">OARD</span> M<span class="small">EMBERS</span>:</p>
<p class="noindent">June Strunk</p>
<p class="noindent">Joella Cruz</p>
<p class="noindent">Bernard Greenwood</p>
<p class="noindent">Paul Girard</p>
<p class="noindent">Alan Slavin</p>
<p class="noindent">David Warr</p>
<p class="noindent1">A<span class="small">UTHORS</span>:</p>
<p class="noindent">Scott Ridley</p>
<p class="noindent">Michael Tougias</p>
<p class="noindent">Will Staples</p>
<p class="noindent">Jennifer Reeser</p>
<p class="noindent1">P<span class="small">UBLISHING</span>:</p>
<p class="noindent">Tris Coburn, literary agent</p>
<p class="noindent">Dani McGrath, Northeast sales, The History Press</p>
<p class="noindent">Tabitha Dulla, commissioning editor, The History Press</p>
<p class="noindent">Darcy Mahan, project editor, The History Press</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?33aadd29